import React, { Component } from "react";
import "./styles.css";
import * as ReactDOMServer from "react-dom/server";
import { Formik, Field, Form } from "formik";
import Header from "../../../components/header";
import Rodape from "../../../components/rodape";
import util from "../../../classes/util";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { PDFExport } from "@progress/kendo-react-pdf";
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import { apiEmployee } from "../../../services/apiamrg";
import loader from "../../../classes/loader";
import moment from "moment";
import Select from "react-select";
import Skeleton from '../../../components/skeleton';
import Modal from "@material-ui/core/Modal";
import JSZip from "jszip";
import { saveAs } from "file-saver";
// Strategies
import ContasReceberStrategy from "./strategies/ContasReceberStrategy";
import ContasPagarStrategy from "./strategies/ContasPagarStrategy";
import ContasPagasStrategy from "./strategies/ContasPagasStrategy";
import ContasRecebidasStrategy from "./strategies/ContasRecebidasStrategy";
// Componentes
import RelatorioTemplate from "./components/RelatorioTemplate";

const estadoInicial = {
  por: "",
  porOptions: [],
  conta: "",
  pessoa: "",
  clientes: [],
  periodoInicial: '',
  periodoFinal: '',
  lancamentoInicial: moment("1900-1-1").format("YYYY-MM-DD"),
  totalBalance: 0,
  moeda: 5,
  moedaSelecao: 5,
  mostrarAmbasMoedas: false,
  moedasOptions: [],
  moedasOptionsTexto: "",
  categoria: "",
  bancoData: null,
  pessoas: [],
  pessoasOptions: [],
  pessoasOptionsTexto: "",
  tiposDocumentoOptions: [],
  grupo: "",
  grupos: [],
  gruposOptions: [],
  gruposOptionsTexto: "",
  vencimentoInicial: "",
  vencimentoFinal: "",
  bloqueado: false,
  relatorio: [],
  pdfgerado: [],
  pdfContent: [],
  pdfNome: "",
  pdfsSeparadosGerados: [],
  pdfEmail: "",
  emails: [],
  temEmail: false,
  failures: [],
  successes: [],
  emailModal: "",
  faturadaHaDias: null,
  banco: '',
  bancosOptions: [],
  bancosOptionsTexto: '',
  pdfsSeparados: false,
  downloadZipAutomatico: false,
  // Dados processados pela Strategy
  dadosProcessados: null,
};

class Relatorio extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef(null);
  }
  state = {
    ...estadoInicial,
    usuarioLogado: this.props.user,
  };

  // ============================================================
  // LIFECYCLE
  // ============================================================
  componentDidMount = async () => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes pulse {
        0% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.7; transform: scale(1.05); }
        100% { opacity: 1; transform: scale(1); }
      }
    `;
    document.head.appendChild(style);
    if (this.state.usuarioLogado.empresa != 0) {
      await this.setState({ empresa: this.state.usuarioLogado.empresa });
    }
    let porOptions = [];
    if (this.props.location.state.backTo) {
      if (
        this.props.location.state.backTo == "contasPagas" ||
        this.props.location.state.backTo == "contasPagar"
      ) {
        porOptions.push({ label: "Por Fornecedor", value: "porCliente" });
        this.setState({ categoria: "_1%" });
      } else {
        porOptions.push({ label: "Por Cliente", value: "porCliente" });
        this.setState({ categoria: "1%" });
      }
      if (this.props.location.state.backTo == "contasPagar") {
        porOptions.push({ label: "Por Vencimento", value: "porVencimento" });
        this.setState({ tipo: "aberto", moeda: 5, moedaSelecao: 5, mostrarAmbasMoedas: false });
      } else if (this.props.location.state.backTo == "contasReceber") {
        porOptions.push({ label: "Por Lançamento", value: "porLancamento" });
        this.setState({ tipo: "aberto" });
      } else {
        porOptions.push({ label: "Por Data de Recebimento", value: "porData" });
        this.setState({ tipo: "liquidado", moeda: 5, moedaSelecao: 5, mostrarAmbasMoedas: false });
      }
      porOptions.push({ label: "Por Número OS", value: "porOS" });
      porOptions.push({ label: "Por Taxa (Serviço)", value: "porTaxa" });
      porOptions.push({ label: "Por Grupo de Taxa", value: "porGrupoTaxa" });
      await this.setState({ porOptions });
    } else {
      this.setState({ redirect: true });
    }
    await this.getPessoasCategorias();
    await this.getTiposDocumento();
    await this.getGrupos();
    await this.loadAll();
  };

  // ============================================================
  // CARREGAMENTO DE DADOS (APIs)
  // ============================================================
  loadAll = async () => {
    const moedasOptions = await loader.getBaseOptions("getMoedas.php", "Descricao", "Chave");
    const backTo = this.props.location?.state?.backTo;
    const moedasOptionsComAmbas =
      backTo == "contasPagas" || backTo == "contasReceber" || backTo == "contasPagar"
        ? [{ label: "Dólar e Real", value: "ambas" }, ...moedasOptions]
        : moedasOptions;
    await this.setState({
      bancosOptions: [{ label: 'Todos', value: '' }, ...await loader.getBaseOptions('getBancosVoucher.php', 'Nome', 'Chave')],
      acessos: await loader.getBase("getTiposAcessos.php"),
      permissoes: await loader.getBase("getPermissoes.php"),
      moedasOptions: moedasOptionsComAmbas,
    });
    await this.setState({
      acessosPermissoes: await loader.testaAcesso(
        this.state.acessos,
        this.state.permissoes,
        this.state.usuarioLogado
      ),
      loading: false,
    });
  };

  getPessoasCategorias = async () => {
    await apiEmployee.post(`getPessoasCategoria.php`, { token: true, categoria: this.state.categoria })
      .then(async (res) => {
        await this.setState({ pessoas: res.data });
        const options = res.data.map((e) => ({
          label: `${e.Nome_Fantasia ? e.Nome_Fantasia : e.Nome}${e.Cnpj_Cpf ? ` - ${util.formataCPF(e.Cnpj_Cpf)}` : ""}`,
          value: e.Chave,
        }));
        await this.setState({ pessoasOptions: options });
      }, (err) => this.erroApi(err));
  };

  getTiposDocumento = async () => {
    await apiEmployee.post(`getTiposLancamento.php`, { token: true })
      .then(async (res) => {
        const tiposDocumentos = res.data.map((e) => ({ ...e, checked: false }));
        await this.setState({ tiposDocumentoOptions: tiposDocumentos });
      }, (err) => this.erroApi(err));
  };

  getGrupos = async () => {
    await apiEmployee.post(`getGruposClientes.php`, { token: true })
      .then(async (res) => {
        await this.setState({ grupos: res.data });
        const options = res.data.map((e) => ({ label: e.descricao, value: e.chave }));
        await this.setState({ gruposOptions: options });
      }, (err) => this.erroApi(err));
  };

  getBancoData = async (bancoChave) => {
    if (!bancoChave) {
      this.setState({ bancoData: null });
      return;
    }
    await apiEmployee.post(`getBancosVoucher.php`, { token: true, chave: bancoChave })
      .then(async (res) => {
        this.setState({ bancoData: res.data?.[0] || null });
      }, () => this.setState({ bancoData: null }));
  };

  getPessoaContatos = async (pessoa) => {
    await apiEmployee.post(`getContatos.php`, { token: true, pessoa })
      .then(async (response) => {
        await this.setState({ contatos: response.data });
        const email = response.data.find((e) => e.Tipo == "EM")?.Campo1
          || response.data.find((e) => e.Tipo == "ER")?.Campo1
          || "";
        await this.setState({
          emails: email ? email.split("; ") : [],
          fornecedorEmail: email,
        });
        await this.setState({ loading: false });
      }, (response) => this.erroApi(response));
  };

  // ============================================================
  // FACTORY DE STRATEGY
  // ============================================================
  getStrategy = () => {
    const backTo = this.props.location.state.backTo;
    const opcoes = {
      moeda: this.state.moeda,
      mostrarAmbasMoedas: this.state.mostrarAmbasMoedas,
      por: this.state.por,
    };
    switch (backTo) {
      case "contasReceber":
        return new ContasReceberStrategy(opcoes);
      case "contasPagar":
        return new ContasPagarStrategy(opcoes);
      case "contasPagas":
        return new ContasPagasStrategy(opcoes);
      case "contasRecebidas":
        return new ContasRecebidasStrategy(opcoes);
      default:
        throw new Error(`Tipo de relatório não suportado: ${backTo}`);
    }
  };

  // ============================================================
  // GERAÇÃO DE RELATÓRIO (ORQUESTRAÇÃO PRINCIPAL)
  // ============================================================
  gerarRelatorio = async (validForm) => {
    this.setState({ loading: true, pdfsSeparadosGerados: [] });
    if (!validForm) return;
    const backTo = this.props.location.state.backTo;
    try {
      let dadosBrutos = [];
      if (backTo === "contasReceber") {
        dadosBrutos = await this.buscarDadosContasReceber();
      } else if (backTo === "contasPagar") {
        dadosBrutos = await this.buscarDadosContasPagar();
      } else {
        dadosBrutos = await this.buscarDadosContasLiquidadas();
      }
      if (!Array.isArray(dadosBrutos)) {
        alert('Erro ao gerar relatório. Resposta inválida do servidor.');
        this.setState({ loading: false });
        return;
      }
      await this.setState({ relatorio: dadosBrutos });
      const strategy = this.getStrategy();
      const dadosProcessados = strategy.processar(dadosBrutos);
      await this.setState({ dadosProcessados });
      const pdfNome = this.gerarNomePDF();
      await this.setState({ pdfNome });
      if (this.state.pdfsSeparados && backTo === "contasReceber") {
        await this.prepararPDFsSeparados(dadosBrutos);
      }
      await this.setState({
        pdfView: true,
        loading: false,
      });
      if (this.state.downloadZipAutomatico && this.state.pdfsSeparadosGerados.length > 0) {
        this.agendarGeracaoZIP();
      }
    } catch (err) {
      console.error('Erro ao gerar relatório:', err);
      alert('Erro ao gerar relatório. Tente novamente.');
      this.setState({ loading: false });
    }
  };

  // ============================================================
  // BUSCAS DE API COM PERÍODO (ATUALIZADAS)
  // ============================================================
  buscarDadosContasReceber = async () => {
    const payload = {
      token: true,
      all: !this.state.clientes[0] ? true : false,
      chaves: this.state.clientes,
      grupo: this.state.grupo || false,
      faturada_ha_dias: this.state.faturadaHaDias,
      periodoInicial: this.state.periodoInicial || null,
      periodoFinal: this.state.periodoFinal || null,
      empresa: this.state.empresa || 1,
    };
    const res = await apiEmployee.post("relatorioContasReceber.php", payload);
    if (this.state.clientes[0] && !this.state.clientes[1]) {
      await this.getPessoaContatos(this.state.clientes[0]);
    }
    return res.data;
  };

  buscarDadosContasPagar = async () => {
    const res = await apiEmployee.post("relatorioContasPagar.php", {
      token: true,
      vencimentoInicial: this.state.vencimentoInicial || null,
      vencimentoFinal: this.state.vencimentoFinal || null,
      pessoa: this.state.clientes[0] ? this.state.clientes : null,
      empresa: this.state.empresa,
    });
    return res.data;
  };

  buscarDadosContasLiquidadas = async () => {
    const backTo = this.props.location.state.backTo;
    let tipo_sub = (backTo == "contasPagas" || backTo == "contasPagar") ? 0 : 1;
    const empresa = this.state.empresa ? `contas_aberto.Empresa = ${this.state.empresa}` : "1=1";
    const abertas = this.state.tipo == "aberto" ? `contas_aberto.Saldo >= 1` : `contas_aberto.Saldo = 0`;
    const conta = this.state.conta ? `contas_aberto.Conta_Contabil = '${this.state.conta}'` : "";
    const pessoa = this.state.clientes[0] ? `contas_aberto.pessoa IN ('${this.state.clientes.join("','")}')` : "";
    const periodoInicial = this.state.periodoInicial
      ? `contas_aberto.data_pagto >= '${this.state.periodoInicial} 00:00:00'`
      : "1=1";
    const periodoFinal = this.state.periodoFinal
      ? `contas_aberto.data_pagto <= '${this.state.periodoFinal} 23:59:59'`
      : "1=1";
    let por = this.state.por;
    if (por == "porCliente") por = "GROUP BY contas_aberto.pessoa ORDER BY pessoas.nome";
    else if (por == "porVencimento") por = "GROUP BY contas_aberto.vencimento ORDER BY contas_aberto.vencimento";
    else if (por == "porLancamento") por = "GROUP BY contas_aberto.Lancto ORDER BY contas_aberto.Lancto";
    else if (por == "porData") por = "GROUP BY contas_aberto.data_pagto ORDER BY contas_aberto.data_pagto";
    else if (por == "porOS") por = "GROUP BY os.codigo ORDER BY os.codigo";
    else if (por == "porTaxa") por = "GROUP BY os_taxas.chave ORDER BY os_taxas.descricao";
    else if (por == "porGrupoTaxa") por = "GROUP BY os_grupos_taxas.chave ORDER BY os_grupos_taxas.descricao";
    let where = [empresa, abertas, conta, pessoa, periodoInicial, periodoFinal]
      .filter((e) => e.trim() != "");
    const res = await apiEmployee.post(`gerarRelatorioContas.php`, {
      token: true,
      where: where.join(" AND "),
      groupBy: por,
      tipo_sub,
    });
    return res.data;
  };

  gerarNomePDF = () => {
    const backTo = this.props.location.state.backTo;
    const data = moment().format("DD-MM-YYYY");
    if (backTo === "contasReceber") {
      const nomeCliente = this.state.clientes[0] && !this.state.clientes[1]
        ? ` - ${this.state.pessoas.find((e) => e.Chave == this.state.clientes[0])?.Nome?.replaceAll(".", "")}`
        : "";
      return `SOA (${data})${nomeCliente}`;
    }
    const nomes = {
      contasPagas: `Relatório de contas pagas (${data})`,
      contasRecebidas: `Relatório de contas recebidas (${data})`,
      contasPagar: `Relatório de contas à pagar (${data})`,
    };
    return nomes[backTo] || `Relatório (${data})`;
  };

  // ============================================================
  // PDFs SEPARADOS
  // ============================================================
  prepararPDFsSeparados = async (dadosBrutos) => {
    let clientesParaPDF = [...this.state.clientes];
    if (clientesParaPDF.length === 0) {
      const clientesUnicos = new Set();
      dadosBrutos.forEach((item) => {
        if (item.contas_normais) {
          item.contas_normais.forEach((conta) => {
            const chave = typeof conta.pessoa === 'object' ? conta.pessoa.chave : conta.pessoa;
            if (chave) clientesUnicos.add(chave.toString());
          });
        }
        if (item.contas_manuais) {
          item.contas_manuais.forEach((conta) => {
            const chave = typeof conta.pessoa === 'object' ? conta.pessoa.chave : conta.pessoa;
            if (chave) clientesUnicos.add(chave.toString());
          });
        }
      });
      clientesParaPDF = Array.from(clientesUnicos);
    }
    const pdfsSeparados = clientesParaPDF.map((clienteId) => {
      const nomeCliente = this.state.pessoas.find((p) => p.Chave == clienteId)?.Nome || `Cliente_${clienteId}`;
      return {
        clienteId,
        nomeCliente: nomeCliente.replaceAll(".", ""),
        pdfNome: `SOA (${moment().format("DD-MM-YYYY")}) - ${nomeCliente.replaceAll(".", "")}`,
      };
    });
    await this.setState({ pdfsSeparadosGerados: pdfsSeparados, downloadZipAutomatico: true });
  };

  agendarGeracaoZIP = () => {
    setTimeout(() => {
      const verificar = () => {
        const encontrados = this.state.pdfsSeparadosGerados
          .map((pdf) => document.getElementById(`pdfDiv_${pdf.clienteId}`))
          .filter((el) => el !== null);
        if (encontrados.length === this.state.pdfsSeparadosGerados.length) {
          this.gerarZipPDFs();
        } else {
          setTimeout(verificar, 500);
        }
      };
      verificar();
    }, 2000);
  };

  gerarZipPDFs = async () => {
    this.mostrarMensagem(`Gerando ${this.state.pdfsSeparadosGerados.length} PDFs...`, 'info');
    const zip = new JSZip();
    let pdfsGerados = 0;
    try {
      for (const pdfData of this.state.pdfsSeparadosGerados) {
        const elementoPDF = document.getElementById(`pdfDiv_${pdfData.clienteId}`);
        if (!elementoPDF) continue;
        const base64 = await drawDOM(elementoPDF, {
          paperSize: "A4",
          margin: "0.5cm",
          scale: 0.6,
          portrait: true,
        }).then((group) => exportPDF(group)).then((dataUri) => dataUri.split(',')[1]);
        if (base64 && base64.length > 100) {
          zip.file(`${pdfData.pdfNome}.pdf`, base64, { base64: true });
          pdfsGerados++;
        }
      }
      if (pdfsGerados > 0) {
        const zipBlob = await zip.generateAsync({ type: "blob" });
        const nomeZip = `SOAs_${moment().format("DD-MM-YYYY")}_${pdfsGerados}_clientes.zip`;
        saveAs(zipBlob, nomeZip);
        this.mostrarMensagem(`✅ ZIP gerado com sucesso: ${nomeZip}`, 'success');
        setTimeout(() => {
          this.setState({
            pdfView: false,
            pdfsSeparadosGerados: [],
            downloadZipAutomatico: false,
          });
        }, 3000);
      } else {
        this.mostrarMensagem('❌ Erro: Nenhum PDF foi gerado com sucesso.', 'error');
      }
    } catch (error) {
      console.error('Erro ao gerar ZIP:', error);
      this.mostrarMensagem('❌ Erro ao gerar arquivo ZIP. Tente novamente.', 'error');
    }
  };

  // ============================================================
  // ENVIO DE EMAIL
  // ============================================================
  enviarEmail = async (validFormEmail) => {
    await this.setState({ successes: [] });
    if (!validFormEmail) return;
    const gridElement = document.getElementById("pdfDiv");
    const base64 = await drawDOM(gridElement, {
      paperSize: "A4",
      margin: "0.5cm",
      scale: 0.6,
      portrait: true,
    }).then((group) => exportPDF(group)).then((dataUri) => dataUri);
    await this.setState({ emailBloqueado: true, loading: true });
    await apiEmployee.post(`enviaRelatorioEmail.php`, {
      token: true,
      emails: this.state.emails.map((e) => e?.trim()),
      mensagem: base64,
      nomeCliente: this.state.pessoas.find((p) => p.Chave == this.state.clientes[0])?.Nome.replaceAll(".", ""),
      balance: `${this.state.moeda == 5 ? "R$" : "USD"} ${this.state.dadosProcessados?.totaisGerais?.balance || 0}`,
      clientId: parseInt(this.state.clientes[0]),
      salvar: !this.state.temEmail,
    }).then(async (res) => {
      const { failures, successes } = res.data;
      await this.setState({ successes, failures, emails: [] });
      if (!failures[0]) await this.setState({ emailModal: false });
    }).catch((res) => console.log(`Erro: ${JSON.stringify(res)}`));
    await this.setState({ emailBloqueado: false, loading: false });
  };

  // ============================================================
  // UTILITÁRIOS
  // ============================================================
  erroApi = async (res) => {
    alert(res);
  };

  mostrarMensagem = (mensagem, tipo = 'info') => {
    const notificacao = document.createElement('div');
    const cores = { info: '#17a2b8', success: '#28a745', error: '#dc3545', warning: '#ffc107' };
    notificacao.style.cssText = `
      position: fixed; top: 20px; right: 20px;
      background: ${cores[tipo] || cores.info}; color: white;
      padding: 15px 20px; border-radius: 5px;
      box-shadow: 0 4px 8px rgba(0,0,0,0.2); z-index: 9999;
      font-family: Arial, sans-serif; font-size: 14px; max-width: 400px;
      opacity: 0; transform: translateX(100%); transition: all 0.3s ease-out;
    `;
    notificacao.textContent = mensagem;
    document.body.appendChild(notificacao);
    setTimeout(() => {
      notificacao.style.opacity = '1';
      notificacao.style.transform = 'translateX(0)';
    }, 10);
    const tempo = tipo === 'error' ? 7000 : 4000;
    setTimeout(() => {
      notificacao.style.opacity = '0';
      notificacao.style.transform = 'translateX(100%)';
      setTimeout(() => notificacao.remove(), 300);
    }, tempo);
  };

  filterSearch = (e, state) => {
    if (e == "") return true;
    return e.label.toUpperCase().includes(state.toUpperCase());
  };

  setTipoDocumento = async (chave, index) => {
    let check = this.state.tiposDocumentoOptions;
    check[index].checked = !check[index].checked;
    await this.setState({ tiposDocumentoOptions: check });
    if (this.state.tiposDocumentos.includes(chave)) {
      await this.setState({ tiposDocumentos: this.state.tiposDocumentos.filter((e) => e != chave) });
    } else {
      this.state.tiposDocumentos.push(chave);
    }
  };

  getTituloEPeriodo = () => {
    const backTo = this.props.location.state.backTo;
    const titulos = {
      contasReceber: 'CONTAS A RECEBER',
      contasPagas: 'CONTAS PAGAS',
      contasRecebidas: 'CONTAS RECEBIDAS',
      contasPagar: 'CONTAS A PAGAR',
    };
    let periodoTitulo = '';
    if (this.state.vencimentoInicial && this.state.vencimentoFinal) {
      periodoTitulo = `DE ${moment(this.state.vencimentoInicial).format('DD/MM/YYYY')} À ${moment(this.state.vencimentoFinal).format('DD/MM/YYYY')}`;
    } else if (this.state.vencimentoInicial) {
      periodoTitulo = `A PARTIR DE ${moment(this.state.vencimentoInicial).format('DD/MM/YYYY')}`;
    } else if (this.state.vencimentoFinal) {
      periodoTitulo = `ATÉ ${moment(this.state.vencimentoFinal).format('DD/MM/YYYY')}`;
    } else if (this.state.periodoInicial && this.state.periodoFinal) {
      periodoTitulo = `DE ${moment(this.state.periodoInicial).format('DD/MM/YYYY')} À ${moment(this.state.periodoFinal).format('DD/MM/YYYY')}`;
    } else if (this.state.periodoInicial) {
      periodoTitulo = `A PARTIR DE ${moment(this.state.periodoInicial).format('DD/MM/YYYY')}`;
    } else if (this.state.periodoFinal) {
      periodoTitulo = `ATÉ ${moment(this.state.periodoFinal).format('DD/MM/YYYY')}`;
    }
    return { titulo: titulos[backTo] || 'RELATÓRIO', periodoTitulo };
  };

  // ============================================================
  // RENDER: CONTEÚDO DO PDF (para PDFs separados)
  // ============================================================
  renderPDFIndividual = (clienteId) => {
    const { dadosProcessados, bancoData } = this.state;
    if (!dadosProcessados) return null;
    const gruposFiltrados = dadosProcessados.grupos
      .map((grupo) => {
        const clienteRows = grupo.rows?.filter((row) => {
          return true; // Ajuste conforme necessário
        });
        if (!clienteRows || clienteRows.length === 0) return null;
        return { ...grupo, rows: clienteRows };
      })
      .filter(Boolean);
    const dadosFiltrados = {
      ...dadosProcessados,
      grupos: gruposFiltrados,
    };
    return (
      <RelatorioTemplate
        titulo={dadosFiltrados.titulo}
        periodoTitulo={this.getTituloEPeriodo().periodoTitulo}
        grupos={dadosFiltrados.grupos}
        totaisGerais={dadosFiltrados.totaisGerais}
        tipo="soa"
        moeda={this.state.moeda}
        mostrarAmbasMoedas={this.state.mostrarAmbasMoedas}
        bancoData={bancoData}
        clienteUnico={!!this.state.clientes[0]}
      />
    );
  };

  // ============================================================
  // RENDER PRINCIPAL
  // ============================================================
  render() {
    const validForm = this.state.por && !this.state.bloqueado;
    const validFormEmail = (this.state.emails[0] || this.state.failures[0]) && !this.state.emailBloqueado;
    const { titulo, periodoTitulo } = this.getTituloEPeriodo();
    const backTo = this.props.location.state.backTo;
    const isContasPagar = backTo === "contasPagar";
    const isSOA = backTo === "contasReceber";

    // ═══════════════════════════════════════════════════════
    // PRINCÍPIO ABERTO/FECHADO: A Strategy decide o formulário
    // ═══════════════════════════════════════════════════════
    const strategy = this.getStrategy();
    const FormComponent = strategy.getFormComponent();

    return (
      <div className="allContent">
        {this.state.loading && <Skeleton />}
        {/* ============================================================ */}
        {/* VISUALIZAÇÃO DO PDF */}
        {/* ============================================================ */}
        {!this.state.loading && (
          <div
            style={{
              position: "absolute", top: 0,
              display: this.state.pdfView ? "flex" : "none",
              width: "100%", minWidth: 830, minHeight: "100vh",
              flexDirection: "column", alignItems: "center",
              backgroundColor: "white", zIndex: 20,
            }}
          >
            <div style={{ width: 830 }}>
              {/* PDF Único (visualização principal) */}
              {this.state.dadosProcessados && (
                <PDFExport
                  fileName={this.state.pdfNome}
                  scale={0.6}
                  portrait={true}
                  paperSize="A4"
                  margin="0.5cm"
                  ref={this.pdfExportComponent}
                >
                  <RelatorioTemplate
                    titulo={this.state.dadosProcessados.titulo}
                    periodoTitulo={periodoTitulo}
                    grupos={this.state.dadosProcessados.grupos}
                    totaisGerais={this.state.dadosProcessados.totaisGerais}
                    tipo={
                      isSOA ? "soa" :
                        isContasPagar ? "contasPagar" :
                          "liquidado"
                    }
                    moeda={this.state.moeda}
                    mostrarAmbasMoedas={this.state.mostrarAmbasMoedas}
                    bancoData={this.state.bancoData}
                    clienteUnico={!!this.state.clientes[0]}
                  />
                </PDFExport>
              )}
              {/* PDFs Separados */}
              {this.state.pdfsSeparadosGerados.length > 0 && (
                <div style={{ marginTop: "40px", borderTop: "2px solid #ccc", paddingTop: "20px" }}>
                  <div style={{
                    textAlign: "center", marginBottom: "20px",
                    backgroundColor: this.state.downloadZipAutomatico ? "#e7f3ff" : "#f8f9fa",
                    padding: "15px", borderRadius: "5px",
                    border: this.state.downloadZipAutomatico ? "2px solid #007bff" : "none",
                  }}>
                    {this.state.downloadZipAutomatico ? (
                      <>
                        <h4 style={{ color: "#007bff", margin: "0" }}>🚀 Download Automático Ativado</h4>
                        <p style={{ margin: "8px 0 0 0", color: "#0056b3", fontSize: "14px", fontWeight: "bold" }}>
                          Um arquivo ZIP com {this.state.pdfsSeparadosGerados.length} PDFs será baixado automaticamente em instantes...
                        </p>
                        <div style={{
                          display: "inline-block", marginTop: "10px", padding: "5px 15px",
                          backgroundColor: "#007bff", color: "white", borderRadius: "20px",
                          fontSize: "12px", animation: "pulse 1.5s infinite",
                        }}>
                          ⬇️ Preparando download...
                        </div>
                      </>
                    ) : (
                      <>
                        <h4 style={{ color: "#495057", margin: "0" }}>📄 PDFs Individuais Preparados para Exportação</h4>
                        <p style={{ margin: "5px 0 0 0", color: "#6c757d", fontSize: "14px" }}>
                          {this.state.pdfsSeparadosGerados.length} arquivo(s) serão gerados separadamente
                        </p>
                      </>
                    )}
                  </div>
                  {this.state.pdfsSeparadosGerados.map((pdfData) => (
                    <div key={pdfData.clienteId} style={{
                      marginBottom: "30px", border: "1px solid #dee2e6",
                      borderRadius: "5px", overflow: "hidden",
                    }}>
                      <div style={{
                        backgroundColor: "#e9ecef", padding: "10px 15px",
                        borderBottom: "1px solid #dee2e6", fontSize: "14px",
                        fontWeight: "500", color: "#495057",
                      }}>
                        📄 {pdfData.pdfNome}
                      </div>
                      <div style={{ backgroundColor: "white" }}>
                        <PDFExport
                          fileName={pdfData.pdfNome}
                          scale={0.6}
                          portrait={true}
                          paperSize="A4"
                          margin="0.5cm"
                          ref={(ref) => this[`pdfExportRef_${pdfData.clienteId}`] = ref}
                        >
                          {this.renderPDFIndividual(pdfData.clienteId)}
                        </PDFExport>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {/* Botões de ação */}
              <div style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "center" }}>
                <button
                  className="btn btn-danger"
                  style={{ margin: 20 }}
                  onClick={() => {
                    if (this.state.pdfsSeparadosGerados.length > 0) {
                      this.state.pdfsSeparadosGerados.forEach((pdfData, index) => {
                        setTimeout(() => {
                          const pdfRef = this[`pdfExportRef_${pdfData.clienteId}`];
                          if (pdfRef) {
                            pdfRef.save();
                          }
                        }, 500 * (index + 1));
                      });
                    } else {
                      if (this.pdfExportComponent.current) {
                        this.pdfExportComponent.current.save();
                      }
                    }
                  }}
                >
                  {this.state.pdfsSeparadosGerados.length > 0
                    ? `Exportar PDFs (${this.state.pdfsSeparadosGerados.length} arquivos)`
                    : "Exportar PDF"}
                </button>
                {this.state.clientes[0] && !this.state.clientes[1] && (
                  <button
                    className="btn btn-info"
                    style={{ margin: 20 }}
                    onClick={() => this.setState({ emailModal: true })}
                  >
                    Enviar por email
                  </button>
                )}
              </div>
              <button
                style={{ position: "absolute", top: 10, left: 10, zIndex: 30, backgroundColor: "inherit", border: "none" }}
                onClick={() => this.setState({ pdfView: false, pdfsSeparadosGerados: [], downloadZipAutomatico: false })}
              >
                <FontAwesomeIcon cursor="pointer" className="seta" icon={faArrowLeft} color="#0d315e" size="2x" />
              </button>
            </div>
          </div>
        )}
        {/* ============================================================ */}
        {/* FORMULÁRIO DE FILTROS (Princípio Aberto/Fechado) */}
        {/* ============================================================ */}
        {!this.state.pdfView && !this.state.loading && (
          <>
            {this.state.redirect && <Redirect to={"/"} />}
            <section>
              {backTo == "contasPagar" && <Header voltarContasPagar relatorio titulo="Contas a Pagar" />}
              {backTo == "contasPagas" && <Header voltarContasPagas relatorio titulo="Contas Pagas" />}
              {backTo == "contasReceber" && <Header voltarContasReceber relatorio titulo="Contas a Receber" />}
              {backTo == "contasRecebidas" && <Header voltarContasRecebidas relatorio titulo="Contas Recebidas" />}
            </section>
            <div style={{ width: "100%", textAlign: "center", marginTop: "-20px", marginBottom: "2%" }}>
              <h6 style={{ color: "red" }}>{this.state.erro}</h6>
            </div>
            <div className="contact-section">
              <div className="row">
                <div className="col-lg-12">
                  {/* ═══════════════════════════════════════════════ */}
                  {/* RENDERIZAÇÃO DINÂMICA DO FORMULÁRIO CORRETO  */}
                  {/* Sem switch, sem if — a Strategy decide         */}
                  {/* ═══════════════════════════════════════════════ */}
                  <FormComponent
                    // ═══ PROPS COMUNS A TODOS OS FORMULÁRIOS ═══
                    porOptions={this.state.porOptions}
                    pessoasOptions={this.state.pessoasOptions}
                    pessoas={this.state.pessoas}
                    filterSearch={this.filterSearch}
                    // Valores comuns
                    por={this.state.por}
                    clientes={this.state.clientes}
                    // Período (comum a todos)
                    periodoInicial={this.state.periodoInicial}
                    periodoFinal={this.state.periodoFinal}
                    // Handlers comuns
                    onPorChange={(val) => this.setState({ por: val })}
                    onPessoasChange={(val) => {
                      if (!this.state.clientes.find((c) => c == val)) {
                        this.setState({
                          clientes: [...this.state.clientes, val],
                          emails: [], failures: [], successes: [],
                        });
                      }
                    }}
                    onRemoverPessoa={(clienteId) => this.setState({
                      clientes: this.state.clientes.filter((c) => c != clienteId),
                      emails: [], failures: [], successes: [],
                    })}
                    onPessoasInputChange={(e) => this.setState({ pessoasOptionsTexto: e })}
                    pessoasOptionsTexto={this.state.pessoasOptionsTexto}
                    onPeriodoInicialChange={(val) => this.setState({ periodoInicial: val })}
                    onPeriodoFinalChange={(val) => this.setState({ periodoFinal: val })}
                    // Submissão
                    onSubmit={() => this.gerarRelatorio(validForm)}
                    validForm={validForm}
                    // ═══ PROPS ESPECÍFICAS (cada formulário usa apenas as que precisa) ═══
                    // Grupo de Clientes (SOA e Liquidadas)
                    gruposOptions={this.state.gruposOptions}
                    grupo={this.state.grupo}
                    onGrupoChange={(val) => this.setState({ grupo: val })}
                    gruposOptionsTexto={this.state.gruposOptionsTexto}
                    onGruposInputChange={(e) => this.setState({ gruposOptionsTexto: e })}
                    // Moeda (SOA e Liquidadas — SOA tem "ambas", Liquidadas não)
                    moedasOptions={this.state.moedasOptions}
                    moedaSelecao={this.state.moedaSelecao}
                    onMoedaChange={(e) => {
                      if (e?.value === "ambas") {
                        this.setState({ moedaSelecao: "ambas", moeda: 5, mostrarAmbasMoedas: true });
                      } else {
                        this.setState({ moedaSelecao: e?.value, moeda: e?.value, mostrarAmbasMoedas: false });
                      }
                    }}
                    moedasOptionsTexto={this.state.moedasOptionsTexto}
                    onMoedasInputChange={(e) => this.setState({ moedasOptionsTexto: e })}
                    // Vencimento (apenas Contas a Pagar)
                    vencimentoInicial={this.state.vencimentoInicial}
                    vencimentoFinal={this.state.vencimentoFinal}
                    onVencimentoInicialChange={(val) => this.setState({ vencimentoInicial: val })}
                    onVencimentoFinalChange={(val) => this.setState({ vencimentoFinal: val })}
                    // Banco (apenas SOA)
                    bancosOptions={this.state.bancosOptions}
                    banco={this.state.banco}
                    onBancoChange={(val) => {
                      this.setState({ banco: val });
                      this.getBancoData(val);
                    }}
                    bancosOptionsTexto={this.state.bancosOptionsTexto}
                    onBancosInputChange={(e) => this.setState({ bancosOptionsTexto: e })}
                    // Enviada há (dias) (apenas SOA)
                    faturadaHaDias={this.state.faturadaHaDias}
                    onFaturadaHaDiasChange={(val) => this.setState({
                      faturadaHaDias: val ? parseInt(val) : null
                    })}
                    // PDFs Separados (apenas SOA)
                    pdfsSeparados={this.state.pdfsSeparados}
                    onPdfsSeparadosChange={(checked) => this.setState({ pdfsSeparados: checked })}
                  />
                </div>
              </div>
            </div>
            <Rodape />
          </>
        )}
        {/* ============================================================ */}
        {/* MODAL DE EMAIL */}
        {/* ============================================================ */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          style={{ display: "flex", justifyContent: "center", paddingTop: "5%", paddingBottom: "5%", overflow: "scroll" }}
          open={this.state.emailModal}
          onClose={async () => await this.setState({ emailModal: false })}
        >
          <div className="modalContainer">
            <div className="modalCriar">
              <div className="containersairlistprodmodal">
                <div className="botaoSairModal" onClick={async () => await this.setState({ emailModal: false })}>
                  <span>X</span>
                </div>
              </div>
              <div className="modalContent">
                <div className="tituloModal">
                  <span>Enviar email:</span>
                </div>
                <div className="modalForm">
                  <Formik
                    initialValues={{ name: "" }}
                    onSubmit={async () => {
                      await new Promise((r) => setTimeout(r, 1000));
                      this.enviarEmail(validFormEmail);
                    }}
                  >
                    <Form className="contact-form">
                      <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                          <div className="row addservicos">
                            {this.state.successes[0] && (
                              <>
                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                  <label>Emails enviados:</label>
                                </div>
                                <div className="col-1 errorMessage"></div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                  <label>
                                    {this.state.successes.map((e, i) => (
                                      <span key={i} className="listaEmail successEmail">
                                        {e}{this.state.successes[i + 1] ? ", " : ""}
                                      </span>
                                    ))}
                                  </label>
                                </div>
                                <div className="col-1"></div>
                              </>
                            )}
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm firstlabel">
                              <label>Destinatário(s)</label>
                            </div>
                            <div className="col-1 errorMessage"></div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                              <Field
                                className="form-control"
                                type="text"
                                value={this.state.emails.join("; ")}
                                onChange={async (e) => this.setState({ emails: e.currentTarget.value.split("; ") })}
                              />
                            </div>
                            <div className="col-1"></div>
                            {this.state.failures[0] && (
                              <>
                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                  <label>Emails inválidos:</label>
                                </div>
                                <div className="col-1 errorMessage"></div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                  <label>
                                    {this.state.failures.map((e, i) => (
                                      <span key={i} className="listaEmail failureEmail" title="Email inválido">
                                        {e}{this.state.failures[i + 1] ? ", " : ""}
                                      </span>
                                    ))}
                                  </label>
                                </div>
                                <div className="col-1"></div>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-1"></div>
                      </div>
                      <div className="row">
                        <div className="col-2"></div>
                        <div className="col-8" style={{ display: "flex", justifyContent: "center" }}>
                          <button
                            disabled={!validFormEmail}
                            type="submit"
                            style={validFormEmail ? { width: 300 } : { backgroundColor: "#eee", opacity: 0.3, width: 300 }}
                          >
                            Enviar
                          </button>
                        </div>
                        <div className="col-2"></div>
                      </div>
                    </Form>
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ user, servidor }) => ({
  user: user,
  online: servidor.online,
});

export default connect(mapStateToProps, null)(Relatorio);